import type { BaseHit } from 'instantsearch.js'

export type PLLHit = BaseHit & {
  objectID: string
  __indexName?: string
  hyperlink?: string
  title?: string
  image?: string
  type?: 'player' | 'team' | 'article' | 'video' | 'general'
  position?: string
  teamName?: string
  date?: string
}

export type ShopifyHit = BaseHit & {
  objectID: string
  __indexName?: string
  handle?: string
  title?: string
  image?: string
  product_type?: string
  price?: number
}

export type SuggestionHit = {
  objectID: string
  __indexName: string
  query: string
}

export type SearchResultItemProps<T extends BaseHit> = {
  item: T
  onSelect: () => void
  query?: string
}

export type SearchHeaderProps<T extends BaseHit> = {
  items: T[]
}

export const SEARCH_TABS = {
  ALL: 'all',
  PLAYERS: 'players',
  NEWS: 'news',
  SHOP: 'shop',
  TEAMS: 'teams',
} as const

export type SearchTab = (typeof SEARCH_TABS)[keyof typeof SEARCH_TABS]

export type TabConfig = {
  id: SearchTab
  label: string
}

export const TAB_CONFIG: TabConfig[] = [
  { id: SEARCH_TABS.ALL, label: 'All Results' },
  { id: SEARCH_TABS.PLAYERS, label: 'Players' },
  { id: SEARCH_TABS.NEWS, label: 'News' },
  { id: SEARCH_TABS.SHOP, label: 'Shop' },
]

export type CategoryResults = {
  players: PLLHit[]
  news: PLLHit[]
  shop: ShopifyHit[]
  teams: PLLHit[]
  general: PLLHit[]
}

export type ResultCounts = {
  players: number
  news: number
  shop: number
  teams: number
  general: number
}

export const SEARCH_INDICES = {
  PLL: 'pll',
  PLAYERS: 'prod_players',
  TEAMS: 'prod_teams',
  POSTS: 'prod_articles',
  VIDEOS: 'prod_videos',
  SHOP: 'shopify_products',
}

export const SEARCH_LABELS = {
  [SEARCH_INDICES.PLL]: 'PLL Results',
  [SEARCH_INDICES.PLAYERS]: 'Players',
  [SEARCH_INDICES.TEAMS]: 'Teams',
  [SEARCH_INDICES.POSTS]: 'Articles',
  [SEARCH_INDICES.VIDEOS]: 'Videos',
  [SEARCH_INDICES.SHOP]: 'Shop',
}
